import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { SmsCampaignService } from 'src/app/modules/retailer/services/sms-campaign.service';

@Component({
  selector: 'app-sms-campaign-list',
  templateUrl: './sms-campaign-list.component.html',
  styleUrls: ['./sms-campaign-list.component.scss']
})
export class SmsCampaignListComponent implements OnInit {

  public loginData: any;

  public stores: any = [];
  public storesLoading: boolean = false;
  public selectedStore: any = 0;

  public smsCampaigns: any = [];
  public smsCampaignsPage: number = 1;
  public smsCampaignsCount: number = 0;
  public smsCampaignsLoading: boolean = false;

  public smsCampaignDetailsPopData: any;

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _smsCampaignService: SmsCampaignService
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  // Go to create sms campaign page
  createSMSCampaign(){
    this._router.navigate(['/retailer/manage-sms-campaign'], {});
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    this.getStores();
  }

  // Get stores
  getStores() {
    this.stores = [];
    this.storesLoading = true;

    let getStoresBody = {
      provider_type: this.loginData.user_details.provider_type,
      provider_id: this.loginData.user_details.provider_id,
      coupon_count: true
    };

    this._smsCampaignService.getStores(this.loginData.token, getStoresBody).subscribe(async getStoresResponse => {
      this.storesLoading = false;

      if (getStoresResponse.status === true) { // Success
        if (getStoresResponse.retailers.length == 1) {
          this.stores = getStoresResponse.retailers[0].stores;

          this.selectedStore = getStoresResponse.retailers[0].stores[0].store_id; // Set first store as default

          this.smsCampaignsPage = 1;
          this.getSMSCampaigns();
        }
      } else {
        this._utilService.showToast(getStoresResponse.message, '', 'error', {});
      }
    }, error => { // Error from getStores
      this.storesLoading = false;
    });
  }

  // Store change
  onStoreChange(event: any) {
    this.smsCampaignsPage = 1;
    this.getSMSCampaigns();
  }

  // Get sms campaigns
  getSMSCampaigns() {
    this.smsCampaigns = [];
    this.smsCampaignsCount = 0;
    this.smsCampaignsLoading = true;

    this._smsCampaignService.getSmsCampaigns(this.loginData.token, this.loginData.user_details.provider_id, this.selectedStore, this.smsCampaignsPage).subscribe(async getSmsCampaignsResponse => {
      this.smsCampaignsLoading = false;

      if (getSmsCampaignsResponse.status === true) { // Success
        this.smsCampaigns = getSmsCampaignsResponse.sms_campaigns;
        this.smsCampaignsCount = getSmsCampaignsResponse.total_count;
      } else {
        this._utilService.showToast(getSmsCampaignsResponse.message, '', 'error', {});
      }
    }, error => { // Error from getSmsCampaigns
      this.smsCampaignsLoading = false;
    });
  }

  // Sms campaign page change
  onSmsCampaignsPageChange(event: any) {
    this.smsCampaignsPage = event;
    this.getSMSCampaigns();
  }

  // Toggle 
  toggleSmsCampaignDetailsPopover(popover, smsCampaign: any) {
		if (popover.isOpen()) {
      this.smsCampaignDetailsPopData = null;
			popover.close();
		} else {
      this.smsCampaignDetailsPopData = smsCampaign;
			popover.open();
		}
	}

  // On edit sms campaign
  onEditSmsCampaign(smsCampaign: any) {
    this._router.navigate(['/retailer/manage-sms-campaign'], {
      state: { 
        smsCampaign: smsCampaign 
      }
    });
  }

}
